import React, { useState, useCallback, useEffect, useRef, useMemo } from 'react'
import Navbar from '../../components/Navbar/Navbar'
import { useTranslation } from 'react-i18next';
import Plus from "@mui/icons-material/Add";
import BackArrow from "@mui/icons-material/ArrowBackIosNew";
import { AutoComplete, Input } from 'antd'
import { debounce } from "@mui/material";
import { getInventoryallproducts } from "../../API  Functions/InventoryFunctions";
import { useSelector } from "react-redux";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import { FormControlLabel, Switch } from "@mui/material";
import axiosInstance from "../../AxiosInstance";
import { URLS } from '../../API/API endpoints';
import { DatePicker } from "antd";
import dayjs from "dayjs"
import CashierOfferTable from "./CashierOfferTable"
import { Modal } from "antd"
import { Checkbox, Select } from "antd";
import { ConfigProvider } from "antd";
import enUS from "antd/locale/en_US";
import arEG from "antd/locale/ar_EG"; // adjust to whatever locale codes you actually support
import Promotions from "./Promotions"

const QUICK_TEMPLATES = [
    { id: "1-1", label: "Buy 1 get 1", x: 1, y: 1 },
    { id: "2-1", label: "Buy 2 get 1", x: 2, y: 1 },
    { id: "5-1", label: "Buy 5 get 1", x: 5, y: 1 },
    { id: "10-2", label: "Buy 10 get 2", x: 10, y: 2 },
    { id: "custom", label: "Custom", x: null, y: null },
];



const Section = ({ title, optional, children }) => (
    <div className="mb-3 rounded-lg border border-gray-200 bg-white p-4">
        <div className="mb-3">
            {typeof title === "string" ? (
                <span className="text-sm font-bold text-[#343C6A]">
                    {title}
                    {optional && (
                        <span className="text-xs font-medium text-[#5B75A1]">
                            (optional)
                        </span>
                    )}
                </span>
            ) : (
                title
            )}
        </div>

        {children}
    </div>
);

const Field = ({ label, children }) => (
    <div className="flex flex-col gap-1 w-full">
        <label className="text-xs font-medium text-[#5B75A1]">{label}</label>
        {children}
    </div>
);

const inputClass =
    "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-[#343C6A] focus:border-primaryBlue focus:outline-none";

const CashierOffers = () => {
    const { t, i18n } = useTranslation();
    const [cashierOfferModal, setCashierOfferModal] = useState(false);
    const [buyQty, setBuyQty] = useState("");           // ← cleared
    const [freeQty, setFreeQty] = useState("");         // ← cleared
    const [promotionId, setPromotionId] = useState(0)
    const [productMap, setProductMap] = useState({});
    const [loading, setloading] = useState(false)
    const [isEditMode, setIsEditMode] = useState(false) // ← NEW

    const [templates, setTemplates] = useState(QUICK_TEMPLATES);

    const [freeOrderLineBill, setFreeOrderLineBill] = useState(null);
    const antdLocale = i18n.language === "ar" ? arEG : enUS;

    const promotionRef = useRef(null);




    const [promotionNameBill, setPromotionNameBill] = useState("");
    // ← cleared
    const [sameAsBuyProduct, setSameAsBuyProduct] = useState(false);
    const [freeQtyBill, setFreeQtyBill] = useState("");


    // Promotion type
    const [promotionType, setPromotionType] = useState("buyXgetY");
    const [activeTemplate, setActiveTemplate] = useState("");   // ← cleared (no pre-selection)
    const [activeTab, setActiveTab] = useState("bulk_discount");

    const [totalBill, setTotalBill] = useState("");

    const offers = [
        { id: "bulk_discount", label: "Bulk Discount" },
        { id: "buy_x_get_y", label: "Buy X Get Y free" },
        // { id: "bill_free_item", label: "Bill total - free item" },
        // { id: "bill_amount_off", label: "Bill total - amount off" },
    ]

    // 1. Promotion info
    const [promotionName, setPromotionName] = useState("");     // ← cleared

    // Set promotion name from template (non-custom), or build from X/Y for custom
    useEffect(() => {
        if (!activeTemplate) return;
        const template = templates.find((t) => t.id === activeTemplate);
        if (!template) return;

        if (template.id === "custom") {
            const x = Number(buyQty) || 0;
            const y = Number(freeQty) || 0;
            if (x > 0 && y > 0) {
                setPromotionName(`Buy ${x} get ${y}`);
            } else {
                setPromotionName("Custom");
            }
        } else {
            setPromotionName(template.label);
        }
    }, [activeTemplate, buyQty, freeQty, templates]);

    // Build promotion name for the "Bill total - free item" flow

    const initialBillLoad = useRef(false);

    const fetchTemplates = async () => {
        const payload = {
            company_id: company_id
        }
        const response = await axiosInstance.post(URLS.GET_CASHIER_OFFER_TYPES, payload);

        console.log(response)

        setTemplates((prev) => {
            const existingLabels = new Set(
                prev.map((t) => t.label.toLowerCase())
            );

            const backendTemplates =
                response?.data?.result?.data?.map((label) => {
                    const match = label.match(/Buy\s+(\d+)\s+get\s+(\d+)/i);
                    let translatedLabel = label;

                    if (match) {
                        translatedLabel = t("Buy {{buy}} get {{free}}", {
                            buy: match[1],
                            free: match[2],
                        });
                    }

                    return {
                        id: crypto.randomUUID(),
                        label: translatedLabel,
                        x: match ? Number(match[1]) : null,
                        y: match ? Number(match[2]) : null,
                    };
                }) || [];

            const uniqueTemplates = backendTemplates.filter(
                (t) => !existingLabels.has(t.label.toLowerCase())
            );

            return [...prev, ...uniqueTemplates];
        });
    };


    useEffect(() => {

        fetchTemplates();
    }, []);

    // useEffect(() => {
    //     if (activeTemplate !== "custom") return;
    //     const x = Number(buyQty) || 0;
    //     const y = Number(freeQty) || 0;
    //     if (x > 0 && y > 0) {
    //         setPromotionName(`Buy ${x} get ${y}`);
    //     }
    // }, [buyQty, freeQty, activeTemplate]);

    const drawerRef = useRef(null)



    useEffect(() => {
        const handleClickOutside = (event) => {
            if (drawerRef.current && !drawerRef.current.contains(event.target)) {
                setCashierOfferModal(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);


    const [promotions, setPromotions] = useState([]);

    // ── "Customer must buy" product search (buy_x_get_y) ────────────────────
    const [buySearchQuery, setBuySearchQuery] = useState("");
    const [buyShowDropdown, setBuyShowDropdown] = useState(false);
    const [buyProductOptions, setBuyProductOptions] = useState([]);
    const [buyOrderLine, setBuyOrderLine] = useState(null);
    const [noResults, setNoResults] = useState(false);
    const [noFreeResults, setNoFreeResults] = useState(false);
    const [buySearchLoading, setBuySearchLoading] = useState(false);
    const [freeSearchLoading, setFreeSearchLoading] = useState(false);


    // ── "Customer gets" (free) product search (buy_x_get_y) ──────────────────
    const [freeSearchQuery, setFreeSearchQuery] = useState("");
    const [freeShowDropdown, setFreeShowDropdown] = useState(false);
    const [freeProductOptions, setFreeProductOptions] = useState([]);
    const [freeOrderLine, setFreeOrderLine] = useState(null);

    // Quantities & prices (buy_x_get_y)
    const [unitPrice, setUnitPrice] = useState("");     // ← cleared
    const [costPrice, setCostPrice] = useState("");     // ← cleared

    // ── "Customer gets" (free) product search — independent state for the
    //     "Bill total - free item" flow so it never collides with buy_x_get_y ──
    const [freeSearchQueryBill, setFreeSearchQueryBill] = useState("");
    const [freeShowDropdownBill, setFreeShowDropdownBill] = useState(false);
    const [freeProductOptionsBill, setFreeProductOptionsBill] = useState([]);
    const [costPriceBill, setCostPriceBill] = useState("");

    const userData = useSelector((state) => state?.login?.user?.result);
    const [showConfirmModal, setShowConfirmModal] = useState(false)

    // 4. Behavior
    const [repeatForMultiple, setRepeatForMultiple] = useState(true);

    // 5. Limits (optional)
    const [maxFreePerOrder, setMaxFreePerOrder] = useState("");
    const [maxUsesPerCustomerDay, setMaxUsesPerCustomerDay] = useState("");
    const [maxUsesTotal, setMaxUsesTotal] = useState("");

    // 6. Validity
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [startDateBillAmount, setStartDateBillAmount] = useState("")
    const [endDateBillAmount, setEndDateBillAmount] = useState("")



    // 7. Customer eligibility
    const [eligibility, setEligibility] = useState("all");
    const [searching, setSearching] = useState(false);
    const [originalPromotions, setOriginalPromotions] = useState([]);
    const [selectedPromotion, setSelectedPromotion] = useState(null);
    const [initialLoad, setInitialLoad] = useState(true);

    const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
    const company_id = useSelector((state) => state?.login?.user?.result?.company_id);

    const [pageLoading, setPageLoading] = useState(true);
    const [currentLimit, setCurrentLimit] = useState(10);
    const [currentOffset, setCurrentOffset] = useState(0);

    const [offersLoading, setOffersLoading] = useState(false);

    //DISCOUNT FOR BILL AMOUNT OFF
    const [promotionNameAmountOff, setPromotionNameAmountOff] = useState("");
    const [totalBillAmountOff, setTotalBillAmountOff] = useState("");
    const [discountType, setDiscountType] = useState("fixed");
    const [discountValue, setDiscountValue] = useState("");

    // ── Reset all form fields to blank ──────────────────────────────────────
    const resetForm = () => {
        setPromotionId(0);
        setPromotionName("");
        setBuyQty("");
        setFreeQty("");
        setSelectedPromotion(null);
        setUnitPrice("");
        setCostPrice("");
        setMaxFreePerOrder("");
        setMaxUsesPerCustomerDay("");
        setMaxUsesTotal("");
        setSameAsBuyProduct(false);
        setStartDate("");
        setEndDate("");
        setActiveTemplate("");
        setEligibility("all");
        setRepeatForMultiple(true);
        setBuyOrderLine(null);
        setFreeOrderLine(null);
        setBuySearchQuery("");
        setFreeSearchQuery("");
        setBuyProductOptions([]);
        setFreeProductOptions([]);

        // Bill total - free item
        setPromotionNameBill("");
        setTotalBill("");
        setFreeQtyBill("");
        setCostPriceBill("");
        setFreeOrderLineBill(null);
        setFreeSearchQueryBill("");
        setFreeProductOptionsBill([]);
        setFreeShowDropdownBill(false);

        // Bill amount off
        setPromotionNameAmountOff("");
        setTotalBillAmountOff("");
        setDiscountType("fixed"); // default value
        setDiscountValue("");

    };

    const handleTemplateClick = (tpl) => {
        setActiveTemplate(tpl.id);
        if (tpl.x && tpl.y) {
            setBuyQty(tpl.x);
            setFreeQty(tpl.y);
        }

    };

    const handlePagination = useCallback((values) => {
        setCurrentLimit(values.limit);
        setCurrentOffset(values.offset);
    }, []);

    const isStepInvalid = useMemo(() => {
        const isMaxFreeInvalid =
            maxFreePerOrder !== "" && Number(maxFreePerOrder) < 0;

        if (activeTab === "buy_x_get_y") {
            const requiredFields = [
                promotionName,
                buyQty,
                freeQty,
                buyOrderLine?.prod_id,
                freeOrderLine?.prod_id,
                unitPrice,
                startDate,
                endDate,
            ];

            return (
                requiredFields.some((field) => !field || field === "") ||
                isMaxFreeInvalid
            );
        }

        if (activeTab === "bill_free_item") {
            const requiredFields = [
                promotionNameBill,
                totalBill,
                freeOrderLineBill?.prod_id,
                freeQtyBill,
                startDate,
                endDate,
            ];

            const isBillInvalid =
                Number(totalBill) < 0 || Number(freeQtyBill) < 0;

            return (
                requiredFields.some((field) => !field || field === "") ||
                isMaxFreeInvalid ||
                isBillInvalid
            );
        }

        if (activeTab === "bill_amount_off") {
            const requiredFields = [
                promotionNameAmountOff,
                totalBillAmountOff,
                discountType,
                discountValue,
                startDate,
                endDate,
            ];

            return requiredFields.some((field) => !field || field === "");
        }

        return false;
    }, [
        activeTab,
        promotionName,
        buyQty,
        freeQty,
        buyOrderLine,
        freeOrderLine,
        unitPrice,
        startDate,
        endDate,
        maxFreePerOrder,
        promotionNameBill,
        totalBill,
        freeOrderLineBill,
        freeQtyBill,

        // Bill Amount Off
        promotionNameAmountOff,
        totalBillAmountOff,
        discountType,
        discountValue,
    ]);
    const handleRowClick = async (promotion) => {
        console.log(promotion)
        setSelectedPromotion(promotion);
        setIsEditMode(true);    // ← enter edit mode
        resetForm();            // ← start clean then populate
        setCashierOfferModal(true);
        const offerType = promotion.promo_offer_type || "buy_x_get_y";
        setActiveTab(offerType);

        try {
            setPromotionId(promotion.promotion_id);

            if (offerType === "bill_free_item") {
                // ── Populate "Bill total - free item" fields ─────────────────
                setPromotionNameBill(t(promotion.name));
                setTotalBill(promotion.name.split(" ")[1])
                setFreeOrderLineBill({
                    prod_id: promotion.free_product_id,
                    name: promotion.free_product_name,
                });
                setFreeSearchQueryBill(promotion.free_product_name ?? "");
                setFreeQtyBill(promotion.free_qty ?? "");
                setCostPriceBill(promotion.free_cost_price ?? "");
            }
            else if (offerType === "bill_amount_off") {
                setPromotionNameAmountOff(promotion.name);
                setTotalBillAmountOff(promotion.bill_amount ?? "");
                setDiscountType(promotion.discount_type ?? "fixed");
                setDiscountValue(promotion.discount_value ?? "");
            } else {
                // ── Populate "Buy X Get Y" fields ────────────────────────────
                setPromotionName(promotion.name);
                if (promotion.buy_product_name == promotion.free_product_name) {
                    setSameAsBuyProduct(true)
                }
                else {
                    setSameAsBuyProduct(false)
                }

                setBuyOrderLine({
                    prod_id: promotion.buy_product_id,
                    name: promotion.buy_product_name,
                    // other fields if available
                });
                setFreeOrderLine({
                    prod_id: promotion.free_product_id,
                    name: promotion.free_product_name,
                });
                setBuySearchQuery(promotion.buy_product_name)
                setFreeSearchQuery(promotion.free_product_name)
                setBuyQty(promotion.buy_qty ?? "");
                setUnitPrice(promotion.buy_unit_price ?? "");


                setFreeQty(promotion.free_qty ?? "");

                const matchedTemplate = templates.find(
                    (t) =>
                        (t.x === promotion.buy_qty && t.y === promotion.free_qty) ||
                        (t.label &&
                            promotion.name &&
                            t.label.trim().toLowerCase() === promotion.name.trim().toLowerCase())
                );

                setActiveTemplate(
                    matchedTemplate ? matchedTemplate.id : "custom"
                );
                setCostPrice(promotion.free_cost_price ?? "");
            }

            // ── Shared fields across all offer types ─────────────────────────
            setMaxFreePerOrder(promotion?.max_free_per_order ? promotion.max_free_per_order : "");
            setMaxUsesPerCustomerDay(promotion?.max_uses_per_customer_day ?? "");
            setMaxUsesTotal(promotion?.max_uses_total ?? "");
            setStartDate(promotion.start_date ?? "");
            setEndDate(promotion.end_date ?? "");
            setRepeatForMultiple(promotion.repeat_for_multiple ?? true);
            setEligibility(promotion.customer_eligibility ?? "all");
        } catch (error) {
            toast.error(t("Failed to fetch promotion details."));

            console.error(error);
        }
    };

    const closeModal = () => {
        setIsEditMode(false);   // ← exit edit mode
        resetForm();
        setCashierOfferModal(false);
    };
    useEffect(() => {
        if (sameAsBuyProduct && buyOrderLine) {
            setFreeOrderLine(buyOrderLine);
            setFreeSearchQuery(buyOrderLine.name);
            setCostPrice(buyOrderLine.cost_price);
        }
    }, [sameAsBuyProduct, buyOrderLine]);

    // ── Map raw API product → orderLine shape ───────────────────────────────
    const mapProduct = (selectedProduct) => ({
        barcode: selectedProduct.barcode,
        machine_barcode: selectedProduct.machine_barcode,
        weight: 0,
        prod_id: selectedProduct.quant_id,
        name:
            selectedProduct.product_name2 && selectedProduct.product_name2 !== ""
                ? selectedProduct.product_name2
                : selectedProduct.product_name,
        cost_price: selectedProduct.current_cost_price,
        sale_price: selectedProduct.discounted_price ?? selectedProduct.current_price,
        qty_available: selectedProduct.system_quantity,
        forecasted_qty: selectedProduct.system_quantity,
        image_url: selectedProduct.product_image_url,
        is_loose: false,
        uom: selectedProduct.uom,
        product_type: "sp",
        is_favorite: false,
        product_main_categ: selectedProduct.categ_id,
        discount_master_id: false,
        discount_qty: selectedProduct.prod_discount ?? 0,
        discount_type: false,
        product_selling_units: [],
        is_package: false,
    });

    const handleBuyProductSelect = (value) => {
        const selected = buyProductOptions.find(
            p =>
                (p.product_name2 && p.product_name2 !== ""
                    ? p.product_name2
                    : p.product_name) === value
        ); console.log(selected)

        if (!selected) return;
        setBuyOrderLine(mapProduct(selected));
        setBuySearchQuery(value);
        setBuyProductOptions([]);
        setBuyShowDropdown(false);
        setUnitPrice(selected?.current_price)
    };

    const handleFreeProductSelect = (value) => {
        const selected = freeProductOptions.find((p) => p.product_name === value);
        if (!selected) return;
        setFreeOrderLine(mapProduct(selected));
        setFreeSearchQuery(value);
        setFreeProductOptions([]);
        setFreeShowDropdown(false);
        setCostPrice(selected?.current_cost_price)
    };

    // ── Free product select for the "Bill total - free item" flow ───────────
    const handleFreeProductSelectBill = (value) => {
        const selected = freeProductOptionsBill.find(
            (p) =>
                (p.product_name2 && p.product_name2 !== ""
                    ? p.product_name2
                    : p.product_name) === value
        );
        if (!selected) return;
        setFreeOrderLineBill(mapProduct(selected));
        setFreeSearchQueryBill(value);
        setFreeProductOptionsBill([]);
        setFreeShowDropdownBill(false);
        setCostPriceBill(selected?.current_cost_price);
    };

    const handleDelete = () => { }

    // ── Build request payload per offer type ─────────────────────────────────
    const buildPayload = () => {
        const shared = {
            company_id: company_id,
            promo_offer_type: activeTab,
            start_date: startDate,
            end_date: endDate,
            max_free_per_order: Number(maxFreePerOrder),
            max_uses_per_customer_day: Number(maxUsesPerCustomerDay),
            max_uses_total: Number(maxUsesTotal),
            repeat_for_multiple: repeatForMultiple,
            customer_eligibility: eligibility,
        };
        const displayFreeQty = Math.floor(Number(freeQtyBill));


        if (activeTab === "bill_free_item") {
            return {
                ...shared,
                name: promotionNameBill,
                bill_amount: Number(totalBill),
                free_product_id: Number(freeOrderLineBill?.prod_id),
                free_qty: displayFreeQty,
                free_cost_price: Number(costPriceBill),
            };
        }

        if (activeTab === "bill_amount_off") {
            return {
                company_id: company_id,
                promo_offer_type: "bill_amount_off",
                name: promotionNameAmountOff,
                start_date: startDate,
                end_date: endDate,
                bill_amount: Number(totalBillAmountOff),
                repeat_for_multiple: true,
                discount_type: discountType,
                discount_value: Number(discountValue),
                customer_eligibility: "all",
            };
        }

        // buy_x_get_y
        return {
            ...shared,
            name: promotionName,
            buy_product_id: Number(buyOrderLine?.prod_id),
            buy_qty: Number(buyQty),
            buy_unit_price: Number(unitPrice),
            free_product_id: Number(freeOrderLine?.prod_id),
            free_qty: Number(freeQty),
            free_cost_price: Number(costPrice),
        };
    };

    // ── Create ───────────────────────────────────────────────────────────────
    const handleCreateCashierOffer = async () => {
        const payload = buildPayload();

        try {
            const res = await axiosInstance.post(URLS.CREATE_CASHIER_OFFER, payload);
            const result = res?.data?.result;
            if (result?.status_code === 200) {
                toast.success(t("Promotion Created"));
                await fetchTemplates();      // reload quick templates

                closeModal();
                getCashierOffer(activeTab);
            } else {
                toast.error(result?.status || t("Failed to create promotion"));
            }
        } catch (error) {
            toast.error(t("Failed to create promotion. Please try again."));
            console.error(error);
        }
    };

    // ── Update ───────────────────────────────────────────────────────────────
    const handleUpdateCashierOffer = async () => {
        const payload = {
            ...buildPayload(),
            promotion_id: promotionId,
        };

        try {
            const res = await axiosInstance.post(URLS.UPDATE_CASHIER_OFFER, payload);
            const result = res?.data?.result;
            if (result?.status_code === 200) {
                toast.success(t("Promotion Updated"));
                closeModal();
                getCashierOffer(activeTab);
            } else {
                toast.error(result?.status || t("Failed to update promotion"));
            }
        } catch (error) {
            toast.error(t("Failed to update promotion. Please try again."));
            console.error(error);
        }
    };

    const getCashierOffer = async (promoOfferType) => {
        setActiveTab(promoOfferType);
        if (promoOfferType === "bulk_discount") return;
        setOffersLoading(true);

        const payload = {
            company_id,
            promo_offer_type: promoOfferType,
            limit: 10,
            offset: 0,
        };

        try {
            const res = await axiosInstance.post(
                URLS.GET_CASHIER_OFFERS,
                payload
            );

            setPromotions(res?.data?.result?.data || []);
        } catch (error) {
            console.error(error);
        } finally {
            setOffersLoading(false);
        }
    };

    const confirmDelete = (promotion) => {
        setSelectedPromotion(promotion)
        setShowConfirmModal(true)
    }

    const deleteCashierOffer = async (promotion) => {
        setloading(true)
        try {
            const payload = {
                company_id: company_id,
                promotion_id: promotion.promotion_id,
                active: false
            }

            const res = await axiosInstance.post(URLS.UPDATE_CASHIER_OFFER, payload)

            if (res?.data?.result?.status_code === 200) {
                toast.success(t("Cashier Offer removed successfully"));
                setShowConfirmModal(false);
                await getCashierOffer(promotion.promo_offer_type);
                setCashierOfferModal(false);
            } else {
                toast.error(res?.status || t("Failed to remove products from group"));
            }
        } catch (error) {
            console.error(error)
            toast.error(t("Failed to remove products from group"));
        } finally {
            setloading(false)
        }
    }

    useEffect(() => {
        getCashierOffer("bulk_discount");
    }, []);

    // ── Separate debounced search functions ─────────────────────────────────
    const searchBuyProduct = useCallback(
        debounce(async (value) => {
            try {
                const response = await getInventoryallproducts(user_id, company_id, false, false, value, 10, 0);
                const results = response?.result?.[0]?.response || [];
                setBuyProductOptions(results);
                setBuyShowDropdown(results.length > 0);
                setNoResults(results.length === 0);
            } catch (error) {
                console.error(error);
                setBuyProductOptions([]);
                setBuyShowDropdown(false);
                setNoResults(true);
            } finally {
                setBuySearchLoading(false);
            }
        }, 1000),
        [user_id, company_id],
    );



    const searchFreeProduct = useCallback(
        debounce(async (value) => {
            try {
                const response = await getInventoryallproducts(user_id, company_id, false, false, value, 10, 0);
                const results = response?.result?.[0]?.response || [];
                setFreeProductOptions(results);
                setFreeShowDropdown(results.length > 0);
                setNoFreeResults(results.length === 0);
            } catch (error) {
                console.error(error);
                setFreeProductOptions([]);
                setFreeShowDropdown(false);
                setNoFreeResults(true);
            } finally {
                setFreeSearchLoading(false);
            }
        }, 1000),
        [user_id, company_id],
    );
    // Independent debounced search for the "Bill total - free item" flow
    const searchFreeProductBill = useCallback(
        debounce(async (value) => {
            try {
                const response = await getInventoryallproducts(user_id, company_id, false, false, value, 10, 0);
                if (response?.result[0]?.response) {
                    setFreeProductOptionsBill(response.result[0].response);
                } else {
                    setFreeProductOptionsBill([]);
                }
            } catch (error) {
                console.error(error);
                setFreeProductOptionsBill([]);
            }
        }, 1000),
        [user_id, company_id],
    );

    // ── Profit impact calculations (Buy X Get Y) ─────────────────────────────
    const x = Number(buyQty) || 0;
    const y = Number(freeQty) || 0;
    const price = Number(unitPrice) || 0;
    const cost = Number(costPrice) || 0;

    const revenue = x * price;
    const grossProfitBefore = revenue - cost * x;
    const freeItemCost = cost * y;
    const profitAfterPromo = grossProfitBefore - freeItemCost;
    const netProfitMargin = revenue > 0 ? (profitAfterPromo / revenue) * 100 : 0;
    const profitDropPercent =
        grossProfitBefore > 0
            ? ((grossProfitBefore - profitAfterPromo) / grossProfitBefore) * 100
            : 0;

    // ── Profit impact calculations (Bill total - free item) ─────────────────
    const billTotalNum = Number(totalBill) || 0;
    const freeQtyBillNum = Number(freeQtyBill) || 0;
    const costPriceBillNum = Number(costPriceBill) || 0;

    const freeItemCostBill = costPriceBillNum * freeQtyBillNum;
    const profitAfterPromoBill = billTotalNum - freeItemCostBill;
    const netProfitMarginBill = billTotalNum > 0 ? (profitAfterPromoBill / billTotalNum) * 100 : 0;
    const profitDropPercentBill = billTotalNum > 0 ? (freeItemCostBill / billTotalNum) * 100 : 0;

    // ── AutoComplete option builder ──────────────────────────────────────────
    const buildOptions = (productList, selectedLine) =>
        productList?.map((prod) => ({
            value:
                prod.product_name2 && prod.product_name2 !== ""
                    ? prod.product_name2
                    : prod.product_name, label: (
                        <div className="flex justify-between items-center">
                            <span>
                                {prod.product_name2 && prod.product_name2 !== ""
                                    ? prod.product_name2
                                    : prod.product_name}
                            </span>
                            {selectedLine?.prod_id === prod.quant_id && (
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                                    stroke="#16A34A" strokeWidth="3"
                                    strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="20 6 9 17 4 12" />
                                </svg>
                            )}
                        </div>
                    ),
            disabled: selectedLine?.prod_id === prod.quant_id,
        }));

    return (
        <div className="flex w-full flex-col overflow-y-auto bg-[#F6F7F9] pb-2 md:h-full">
            <Navbar heading={t("Promotions")} />
            <div className="custom-scrollbar ms-1 mt-2 flex-grow overflow-y-auto overflow-hidden sm:ms-3">
                <div className="font-extrabold mb-3"></div>
                <div className="mt-3">
                    <div className="flex justify-between mt-3 me-8">
                        <div className='w-8'></div>
                        <button
                            className="flex h-10 w-full items-center justify-center gap-2 rounded-lg bg-primaryBlue text-sm font-semibold text-white sm:w-48"
                            onClick={() => {
                                if (activeTab === "bulk_discount") {
                                    promotionRef.current?.openCreateModal();
                                } else {
                                    resetForm();
                                    setIsEditMode(false);
                                    setCashierOfferModal(true);
                                }
                            }}
                        >
                            <Plus style={{ fontSize: "1.5em", MozMarginStart: -10 }} />

                            <span>
                                {activeTab === "bulk_discount" ? t("Create Bulk Discount") : t("Create Promotion")}
                            </span>
                        </button>

                    </div>
                </div>
            </div>

            <div className="flex-1 overflow-hidden px-1 md:px-3 mt-4 mb-4">
                <div className="bg-white rounded-xl h-full flex flex-col">
                    <div className="sticky top-0 z-40 bg-white border-b px-4 py-3 flex gap-4 overflow-x-auto">
                        {offers.map((val, i) => (
                            <div
                                key={i}
                                onClick={() => { getCashierOffer(val.id) }}
                                className={`cursor-pointer px-4 py-2 rounded-md font-medium whitespace-nowrap transition-all
                                    ${activeTab === val.id
                                        ? "bg-[#E6F0FF] text-[#1D4ED8] border border-[#1D4ED8]"
                                        : "text-[#6B7280] hover:bg-gray-100"
                                    }`}
                            >
                                {t(val.label)}
                            </div>
                        ))}
                    </div>

                    {activeTab === "bulk_discount" ? <Promotions ref={promotionRef} /> :
                        <CashierOfferTable
                            additionalData={promotions}
                            pagination={handlePagination}
                            onRowClick={handleRowClick}
                            onEditLine={handleRowClick}
                            onDelete={confirmDelete}
                            showEdit={!userData?.is_sub_store && !userData?.is_warehouse}
                            activeTab={activeTab}
                            totalBill={totalBill}
                            loading={offersLoading}

                        />
                    }

                    <Modal
                        open={showConfirmModal}
                        onCancel={() => setShowConfirmModal(false)}
                        footer={null}
                        centered
                        closable={false}
                    >
                        <div className="text-center p-6">
                            <h3 className="text-lg font-semibold mb-4 text-gray-800">
                                {t("Are you sure you want to delete this promotion ?")}
                            </h3>
                            <div className="flex justify-center gap-4 mt-6">
                                <button
                                    onClick={() => setShowConfirmModal(false)}
                                    className="px-6 py-2 rounded-lg border border-gray-300 hover:bg-gray-100 text-gray-700 font-semibold"
                                >
                                    {t("No")}
                                </button>
                                <button
                                    onClick={() => deleteCashierOffer(selectedPromotion)}
                                    disabled={loading}
                                    className="px-6 py-2 rounded-lg bg-[#FF1616] hover:bg-[#e01414] text-white font-semibold"
                                >
                                    {loading ? t("Removing...") : t("Yes")}
                                </button>
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>

            {cashierOfferModal && (
                <div className="fixed inset-0 z-40 bg-black bg-opacity-50" onMouseDown={() => {
                    setCashierOfferModal(false);

                }}>
                    <div className={`fixed top-0 right-0 z-50 h-screen w-[700px] bg-white shadow-lg
                        transform transition-transform duration-300 flex flex-col
                        ${cashierOfferModal ? "translate-x-0" : "translate-x-full"}`}
                        onMouseDown={(e) => e.stopPropagation()} // ✅ stops backdrop from firing

                    >

                        {/* Header */}
                        <div className="flex-shrink-0 px-6 pt-6 pb-4 border-b border-gray-200">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-2">
                                    <BackArrow
                                        style={{ fontSize: "1.5em", cursor: "pointer", width: "25px", height: "15px", marginTop: "2px" }}
                                        onClick={closeModal}
                                    />
                                    <span className="text-md font-bold flex flex-col gap-1">
                                        {isEditMode ? t("Edit Cashier Offer") : t("Create Cashier Offer")}

                                        {isEditMode && (
                                            <span className="text-xs text-gray-500">
                                                {t("Promotion ID")}: #{promotionId}
                                            </span>
                                        )}
                                    </span>

                                </div>

                                {/* ← Save calls update or create depending on mode */}
                                <button
                                    disabled={isStepInvalid}
                                    className="px-5 py-1.5 text-sm font-semibold border rounded-lg transition-colors disabled:opacity-50 bg-primaryBlue text-white hover:opacity-90 border-primaryBlue"
                                    onClick={isEditMode ? handleUpdateCashierOffer : handleCreateCashierOffer}
                                >
                                    {t("Save")}
                                </button>
                            </div>
                        </div>

                        {/* Scrollable body */}
                        <div className="custom-scrollbar flex-grow overflow-y-auto px-6 py-4">
                            <div className="mb-4">
                                <div className="mb-4 flex flex-col items-center justify-between">
                                    <div className="mt-5 flex gap-6">
                                        {!selectedPromotion &&
                                            offers
                                                .filter((tab) => tab.id !== "bulk_discount")
                                                .map((tab) => (
                                                    <button
                                                        key={tab.id}
                                                        className={`rounded-full h-auto px-3 py-1.5 text-xs font-semibold transition-colors border
          ${activeTab === tab.id
                                                                ? "bg-primaryBlue text-white border-primaryBlue"
                                                                : "border-primaryBlue text-black"}`}
                                                        onClick={() => setActiveTab(tab.id)}
                                                    >
                                                        {t(tab.label)}
                                                    </button>
                                                ))}
                                    </div>
                                </div>




                                {activeTab === "buy_x_get_y" && (
                                    <div>
                                        {/* Quick templates */}
                                        <div className="mb-4">
                                            <span className="mb-2 block text-xs font-semibold min-w-[650px] uppercase text-[#5B75A1]">
                                                {t("Quick templates")}
                                            </span>
                                            <div className="flex flex-wrap gap-2">
                                                {templates.map((tpl) => (
                                                    <button
                                                        key={tpl.id}
                                                        type="button"
                                                        onClick={() => handleTemplateClick(tpl)}
                                                        className={`rounded-full px-3 py-1.5 text-xs font-semibold transition-colors
                                                            ${activeTemplate === tpl.id
                                                                ? "bg-primaryBlue text-white"
                                                                : "bg-[#F6F7F9] text-[#5B75A1] hover:bg-gray-200"}`}
                                                    >
                                                        {t(tpl.label)}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>

                                        {/* 1. Promotion info */}
                                        {/* <Section number={1} title={t("Promotion info")}>
                                            <Field label={t("Promotion name")}>
                                                <input
                                                    type="text"
                                                    className={inputClass}
                                                    value={promotionName}
                                                    onChange={(e) => setPromotionName(e.target.value)}
                                                    disabled
                                                />
                                            </Field>
                                        </Section> */}

                                        {/* 2. Customer must buy */}
                                        <Section title={t("Customer must buy")}>
                                            <div className="flex gap-4 items-start">
                                                <div className="flex-[4]">
                                                    <Field label={t("Product")}>
                                                        <AutoComplete
                                                            className="w-full"
                                                            value={buySearchQuery}
                                                            style={{ width: "100%", height: "43px" }}
                                                            open={buyShowDropdown}
                                                            onDropdownVisibleChange={(open) => setBuyShowDropdown(open)}
                                                            options={buildOptions(buyProductOptions, buyOrderLine)}
                                                            filterOption={false}
                                                            onSearch={(val) => {
                                                                setBuySearchQuery(val);
                                                                if (val.length >= 2) {
                                                                    setNoResults(false);
                                                                    setBuySearchLoading(true);
                                                                    searchBuyProduct(val);
                                                                } else {
                                                                    setBuyProductOptions([]);
                                                                    setBuyShowDropdown(false);
                                                                    setNoResults(false);
                                                                    setBuySearchLoading(false);
                                                                }
                                                            }}
                                                            onSelect={handleBuyProductSelect}
                                                        >
                                                            <Input
                                                                placeholder={t("search_product")}
                                                                size="large"
                                                                style={{ borderColor: "#d9d9d9", boxShadow: "none" }}
                                                                suffix={
                                                                    buySearchQuery ? (
                                                                        <CloseOutlined
                                                                            onClick={() => {
                                                                                setBuySearchQuery("");
                                                                                setBuyOrderLine(null);
                                                                                setBuyProductOptions([]);
                                                                                setBuyShowDropdown(false);
                                                                                setUnitPrice("");
                                                                            }}
                                                                            style={{ cursor: "pointer" }}
                                                                        />
                                                                    ) : (
                                                                        <SearchOutlined />
                                                                    )
                                                                }
                                                            />
                                                        </AutoComplete>

                                                        {!buySearchLoading &&
                                                            noResults &&
                                                            buySearchQuery.length >= 2 &&
                                                            buyProductOptions.length === 0 && (
                                                                <div className="mt-1 text-sm text-red-500">
                                                                    {t("No matching products found")}
                                                                </div>
                                                            )}
                                                    </Field>
                                                </div>

                                                <div className="w-32">
                                                    <Field label={t("Quantity (X)")}>
                                                        <input
                                                            type="number"
                                                            min="1"
                                                            className={inputClass}
                                                            value={buyQty}
                                                            onChange={(e) => setBuyQty(e.target.value)}
                                                            disabled={activeTemplate !== "custom" && activeTemplate !== ""}
                                                        />
                                                    </Field>
                                                </div>
                                            </div>
                                        </Section>
                                        {/* 3. Customer gets */}
                                        <Section
                                            title={
                                                <div className="flex items-center justify-between w-full">
                                                    <span className="text-sm font-bold text-[#343C6A]">
                                                        {t("Customer gets")}
                                                    </span>



                                                    <Checkbox
                                                        checked={sameAsBuyProduct}
                                                        onChange={(e) => {
                                                            const checked = e.target.checked;
                                                            setSameAsBuyProduct(checked);

                                                            if (checked) {
                                                                setFreeOrderLine(buyOrderLine);
                                                                setFreeSearchQuery(buyOrderLine?.name || "");
                                                            } else {
                                                                setFreeOrderLine(null);
                                                                setFreeSearchQuery("");
                                                                setFreeProductOptions([]);
                                                                setFreeShowDropdown(false);
                                                            }
                                                        }}
                                                    >
                                                        {t("Same as buy product")}
                                                    </Checkbox>
                                                </div>
                                            }
                                        >                                            <div className="flex gap-4 items-start">
                                                <div className="flex-[4]">
                                                    <Field label={t("Free product")}>
                                                        <AutoComplete
                                                            className="w-full"
                                                            value={freeSearchQuery}
                                                            style={{ width: "100%", height: "43px" }}
                                                            open={freeShowDropdown}
                                                            onDropdownVisibleChange={(open) => setFreeShowDropdown(open)}
                                                            options={buildOptions(freeProductOptions, freeOrderLine)}
                                                            filterOption={false}
                                                            onSearch={(val) => {
                                                                setFreeSearchQuery(val);
                                                                if (val.length >= 2) {
                                                                    setNoFreeResults(false);
                                                                    setFreeSearchLoading(true);
                                                                    searchFreeProduct(val);
                                                                } else {
                                                                    setFreeProductOptions([]);
                                                                    setFreeShowDropdown(false);
                                                                    setNoFreeResults(false);
                                                                    setFreeSearchLoading(false);
                                                                }
                                                            }}
                                                            onSelect={handleFreeProductSelect}
                                                        >
                                                            <Input
                                                                placeholder={t("search_product")}
                                                                size="large"
                                                                style={{ borderColor: "#d9d9d9", boxShadow: "none" }}
                                                                suffix={
                                                                    freeSearchQuery ? (
                                                                        <CloseOutlined
                                                                            onClick={() => {
                                                                                setFreeSearchQuery("");
                                                                                setFreeOrderLine(null);
                                                                                setFreeProductOptions([]);
                                                                                setFreeShowDropdown(false);
                                                                                setCostPrice("");
                                                                            }}
                                                                            style={{ cursor: "pointer" }}
                                                                        />
                                                                    ) : (
                                                                        <SearchOutlined />
                                                                    )
                                                                }
                                                            />
                                                        </AutoComplete>

                                                        {!freeSearchLoading &&
                                                            noFreeResults &&
                                                            freeSearchQuery.length >= 2 &&
                                                            freeProductOptions.length === 0 && (
                                                                <div className="mt-1 text-sm text-red-500">
                                                                    {t("No matching products found")}
                                                                </div>
                                                            )}
                                                    </Field>
                                                </div>

                                                <div className="w-32">
                                                    <Field label={t("Free qty (Y)")}>
                                                        <>
                                                            <input
                                                                type="number"
                                                                min="1"
                                                                className={inputClass}
                                                                value={freeQty}
                                                                onChange={(e) => setFreeQty(e.target.value)}
                                                                disabled={activeTemplate !== "custom" && activeTemplate !== ""}
                                                            />
                                                        </>
                                                    </Field>
                                                </div>
                                            </div>
                                        </Section>

                                        {/* 4. Limits */}
                                        <Section title={t("Limits")} optional>
                                            <div className="flex gap-3">
                                                <Field label={t("Max free items per order")}>
                                                    <input
                                                        type="number"
                                                        min="0"
                                                        placeholder={t("No limit")}
                                                        className={inputClass}
                                                        value={maxFreePerOrder}
                                                        onChange={(e) => setMaxFreePerOrder(e.target.value)}
                                                    />
                                                    <span className="text-[11px] text-[#A4AFC1]">{t("e.g. 5")}</span>
                                                </Field>
                                                {/* <Field label={t("Max uses per customer / day")}>
                                                    <input
                                                        type="number"
                                                        min="0"
                                                        placeholder={t("No limit")}
                                                        className={inputClass}
                                                        value={maxUsesPerCustomerDay}
                                                        onChange={(e) => setMaxUsesPerCustomerDay(e.target.value)}
                                                    />
                                                    <span className="text-[11px] text-[#A4AFC1]">{t("e.g. 1")}</span>
                                                </Field>
                                                <Field label={t("Max uses total")}>
                                                    <input
                                                        type="number"
                                                        min="0"
                                                        placeholder={t("No limit")}
                                                        className={inputClass}
                                                        value={maxUsesTotal}
                                                        onChange={(e) => setMaxUsesTotal(e.target.value)}
                                                    />
                                                    <span className="text-[11px] text-[#A4AFC1]">{t("e.g. 200")}</span>
                                                </Field> */}
                                            </div>
                                        </Section>

                                        {/* 5. Validity */}
                                        <Section title={t("Validity")}>
                                            <div className="flex gap-4">
                                                <div className="flex-1">
                                                    <label className="mb-2 block text-[12px] font-medium text-gray-700">
                                                        {t("Start Date")}
                                                    </label>
                                                    <ConfigProvider locale={antdLocale}>
                                                        <DatePicker
                                                            className="w-full h-[40px]"
                                                            showTime={{ format: "HH:mm" }}
                                                            format="YYYY-MM-DD HH:mm"
                                                            placeholder={t("Select Date")}
                                                            value={startDate ? dayjs(startDate) : null}
                                                            onChange={(date) =>
                                                                setStartDate(date ? date.format("YYYY-MM-DD HH:mm:[00]") : "")
                                                            }
                                                            disabledDate={(current) =>
                                                                current && current < dayjs().startOf("day")
                                                            }
                                                        />
                                                    </ConfigProvider>
                                                </div>

                                                <div className="flex-1">
                                                    <label className="mb-2 block text-[12px] font-medium text-gray-700">
                                                        {t("End Date")}
                                                    </label>
                                                    <ConfigProvider locale={antdLocale}>
                                                        <DatePicker
                                                            className="w-full h-[40px]"
                                                            showTime={{ format: "HH:mm" }}
                                                            format="YYYY-MM-DD HH:mm"
                                                            placeholder={t("Select Date")}
                                                            value={endDate ? dayjs(endDate) : null}
                                                            onChange={(date) =>
                                                                setEndDate(date ? date.format("YYYY-MM-DD HH:mm:[00]") : "")
                                                            }
                                                            disabledDate={(current) =>
                                                                current &&
                                                                current < (startDate ? dayjs(startDate).startOf("day") : dayjs().startOf("day"))
                                                            }
                                                        />
                                                    </ConfigProvider>
                                                </div>
                                            </div>
                                        </Section>

                                        {/* 6. Profit impact */}
                                        <Section title={t("Profit impact")}>
                                            <div className="grid grid-cols-3 gap-3">
                                                <div>
                                                    <p className="text-xs text-[#5B75A1]">{t("Revenue (X × unit price)")}</p>
                                                    <p className="text-sm font-bold text-[#343C6A]">EGP {revenue.toFixed(2)}</p>
                                                </div>
                                                <div>
                                                    <p className="text-xs text-[#5B75A1]">{t("Gross profit (before promo)")}</p>
                                                    <p className={`text-sm font-bold ${grossProfitBefore >= 0 ? "text-[#343C6A]" : "text-red-500"}`}>
                                                        EGP {grossProfitBefore.toFixed(2)}
                                                    </p>
                                                </div>
                                                <div>
                                                    <p className="text-xs text-[#5B75A1]">{t("Profit after promo")}</p>
                                                    <p className={`text-sm font-bold ${profitAfterPromo >= 0 ? "text-[#343C6A]" : "text-red-500"}`}>
                                                        EGP {profitAfterPromo.toFixed(2)}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="mt-3 flex items-center justify-between border-t border-gray-100 pt-3">
                                                <span className="text-xs text-[#5B75A1]">{t("Free item cost (Y × cost price)")}</span>
                                                <span className="text-sm font-semibold text-[#343C6A]">EGP {freeItemCost.toFixed(2)}</span>
                                            </div>
                                            <div className="mt-1 flex items-center justify-between">
                                                <span className="text-xs text-[#5B75A1]">{t("Net profit margin")}</span>
                                                <span className={`text-sm font-semibold ${netProfitMargin >= 0 ? "text-[#343C6A]" : "text-red-500"}`}>
                                                    {netProfitMargin.toFixed(1)}%
                                                </span>
                                            </div>

                                            {profitDropPercent >= 50 && (
                                                <div className="mt-3 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-xs font-medium text-red-600">
                                                    {t("Profit reduced by {{percent}}%. Review before activating.", {
                                                        percent: profitDropPercent.toFixed(0),
                                                    })}
                                                </div>
                                            )}
                                        </Section>
                                    </div>
                                )}
                                {
                                    activeTab === "bill_free_item" && (
                                        <div className="flex flex-col gap-4 min-w-[650px]">
                                            {/* <Section number={1} title={t("Promotion info")}>
                                                <Field label={t("Promotion name")}>
                                                    <input
                                                        type="text"
                                                        className={inputClass}
                                                        value={promotionNameBill}

                                                        disabled
                                                    />
                                                </Field>
                                            </Section> */}
                                            <Section title={t("Total bill")}>
                                                <Field label={t("Total Bill (EGP)")}>
                                                    <input
                                                        type="number"
                                                        min="0"
                                                        className={inputClass}
                                                        value={totalBill}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            setTotalBill(value);
                                                            setPromotionNameBill(
                                                                t("buy_get_offer", {
                                                                    buyQty: value || 0,
                                                                    freeQty: freeQtyBill || 0,
                                                                })
                                                            );
                                                        }}
                                                    />
                                                </Field>
                                            </Section>
                                            <Section title={t("Customer gets")}>
                                                <div className="flex flex-col gap-4">
                                                    <Field label={t("Free product")}>
                                                        <AutoComplete
                                                            className="flex-1 w-full"
                                                            value={freeSearchQueryBill}
                                                            style={{ width: "100%", height: "43px" }}
                                                            open={freeShowDropdownBill}
                                                            onDropdownVisibleChange={(open) => setFreeShowDropdownBill(open)}
                                                            options={buildOptions(freeProductOptionsBill, freeOrderLineBill)}
                                                            filterOption={false}
                                                            onSearch={(val) => {
                                                                setFreeSearchQueryBill(val);
                                                                if (val.length >= 2) {
                                                                    searchFreeProductBill(val);
                                                                    setFreeShowDropdownBill(true);
                                                                } else {
                                                                    setFreeProductOptionsBill([]);
                                                                    setFreeShowDropdownBill(false);
                                                                }
                                                            }}
                                                            onSelect={handleFreeProductSelectBill}
                                                        >
                                                            <Input
                                                                placeholder={t("search_product")}
                                                                size="large"
                                                                style={{ borderColor: "#d9d9d9", boxShadow: "none" }}
                                                                suffix={
                                                                    freeSearchQueryBill ? (
                                                                        <CloseOutlined
                                                                            onClick={() => {
                                                                                setFreeSearchQueryBill("");
                                                                                setFreeOrderLineBill(null);
                                                                                setFreeProductOptionsBill([]);
                                                                                setFreeShowDropdownBill(false);
                                                                                setCostPriceBill("")
                                                                            }}
                                                                            style={{ cursor: "pointer" }}
                                                                        />
                                                                    ) : (
                                                                        <SearchOutlined />
                                                                    )
                                                                }
                                                            />
                                                        </AutoComplete>
                                                    </Field>
                                                    <div className="flex gap-3 w-full">
                                                        <Field label={t("Free qty (Y)")}>
                                                            <input
                                                                type="number"
                                                                min="1"
                                                                className={inputClass}
                                                                value={freeQtyBill}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    console.log(value, totalBill)
                                                                    setFreeQtyBill(value);
                                                                    const displayQty = Math.floor(Number(value || 0));

                                                                    setPromotionNameBill(`Buy ${totalBill || 0} Get ${displayQty}`);
                                                                }} />
                                                        </Field>
                                                        {/* <Field label={t("Cost price (EGP)")}>
                                                            <input
                                                                type="number"
                                                                min="0"
                                                                className={inputClass}
                                                                value={costPriceBill}
                                                                onChange={(e) => setCostPriceBill(e.target.value)}
                                                            />
                                                        </Field> */}
                                                    </div>
                                                </div>
                                            </Section>

                                            {/* 4. Limits */}
                                            <Section title={t("Limits")} optional>
                                                <div className="flex gap-3">
                                                    <Field label={t("Max free items per order")}>
                                                        <input
                                                            type="number"
                                                            min="0"
                                                            placeholder={t("No limit")}
                                                            className={inputClass}
                                                            value={maxFreePerOrder}
                                                            onChange={(e) => setMaxFreePerOrder(e.target.value)}
                                                        />
                                                        <span className="text-[11px] text-[#A4AFC1]">{t("e.g. 5")}</span>
                                                    </Field>
                                                    {/* <Field label={t("Max uses per customer / day")}>
                                                        <input
                                                            type="number"
                                                            min="0"
                                                            placeholder={t("No limit")}
                                                            className={inputClass}
                                                            value={maxUsesPerCustomerDay}
                                                            onChange={(e) => setMaxUsesPerCustomerDay(e.target.value)}
                                                        />
                                                        <span className="text-[11px] text-[#A4AFC1]">{t("e.g. 1")}</span>
                                                    </Field>
                                                    <Field label={t("Max uses total")}>
                                                        <input
                                                            type="number"
                                                            min="0"
                                                            placeholder={t("No limit")}
                                                            className={inputClass}
                                                            value={maxUsesTotal}
                                                            onChange={(e) => setMaxUsesTotal(e.target.value)}
                                                        />
                                                        <span className="text-[11px] text-[#A4AFC1]">{t("e.g. 200")}</span>
                                                    </Field> */}
                                                </div>
                                            </Section>

                                            {/* 5. Validity */}
                                            <Section title={t("Validity")}>
                                                <div className="grid grid-cols-2 gap-3">
                                                    <Field label={t("Start date")}>
                                                        <DatePicker
                                                            className="w-full h-[40px]"
                                                            showTime={{ format: "HH:mm" }}
                                                            format="YYYY-MM-DD HH:mm"
                                                            value={startDate ? dayjs(startDate) : null}
                                                            onChange={(date) =>
                                                                setStartDate(date ? date.format("YYYY-MM-DD HH:mm:[00]") : "")
                                                            }
                                                            disabledDate={(current) =>
                                                                current && current < dayjs().startOf("day")
                                                            }
                                                        />
                                                    </Field>
                                                    <Field label={t("End date")}>
                                                        <DatePicker
                                                            className="w-full h-[40px]"
                                                            showTime={{ format: "HH:mm" }}
                                                            format="YYYY-MM-DD HH:mm"
                                                            value={endDate ? dayjs(endDate) : null}
                                                            onChange={(date) =>
                                                                setEndDate(date ? date.format("YYYY-MM-DD HH:mm:[00]") : "")
                                                            }
                                                            disabledDate={(current) =>
                                                                current &&
                                                                current < (startDate ? dayjs(startDate).startOf("day") : dayjs().startOf("day"))
                                                            }
                                                        />
                                                    </Field>
                                                </div>
                                            </Section>

                                            {/* 6. Profit impact */}
                                            <Section title={t("Profit impact")}>
                                                <div className="grid grid-cols-3 gap-3">
                                                    <div>
                                                        <p className="text-xs text-[#5B75A1]">{t("Total bill")}</p>
                                                        <p className="text-sm font-bold text-[#343C6A]">EGP {billTotalNum.toFixed(2)}</p>
                                                    </div>
                                                    <div>
                                                        <p className="text-xs text-[#5B75A1]">{t("Free item cost (Y × cost price)")}</p>
                                                        <p className="text-sm font-bold text-[#343C6A]">EGP {freeItemCostBill.toFixed(2)}</p>
                                                    </div>
                                                    <div>
                                                        <p className="text-xs text-[#5B75A1]">{t("Profit after promo")}</p>
                                                        <p className={`text-sm font-bold ${profitAfterPromoBill >= 0 ? "text-[#343C6A]" : "text-red-500"}`}>
                                                            EGP {profitAfterPromoBill.toFixed(2)}
                                                        </p>
                                                    </div>
                                                </div>

                                                <div className="mt-1 flex items-center justify-between">
                                                    <span className="text-xs text-[#5B75A1]">{t("Net profit margin")}</span>
                                                    <span className={`text-sm font-semibold ${netProfitMarginBill >= 0 ? "text-[#343C6A]" : "text-red-500"}`}>
                                                        {netProfitMarginBill.toFixed(1)}%
                                                    </span>
                                                </div>

                                                {profitDropPercentBill >= 50 && (
                                                    <div className="mt-3 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-xs font-medium text-red-600">
                                                        {t("Profit reduced by {{percent}}%. Review before activating.", {
                                                            percent: profitDropPercentBill.toFixed(0),
                                                        })}
                                                    </div>
                                                )}
                                            </Section>
                                        </div>
                                    )
                                }
                                {
                                    activeTab === "bill_amount_off" && (
                                        <div className="flex flex-col gap-4 min-w-[650px]">
                                            {/* Promotion Info */}
                                            {/* <Section title={t("Promotion info")}>
                                                <Field label={t("Promotion name")}>
                                                    <input
                                                        type="text"
                                                        className={inputClass}
                                                        value={promotionNameAmountOff}
                                                        onChange={(e) => setPromotionNameAmountOff(e.target.value)}
                                                    />
                                                </Field>
                                            </Section> */}

                                            <Section title={t("Total bill")}>
                                                <Field label={t("Total Bill (EGP)")}>
                                                    <input
                                                        type="number"
                                                        min="0"
                                                        className={inputClass}
                                                        value={totalBillAmountOff}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            setTotalBillAmountOff(value);

                                                            setPromotionNameAmountOff(
                                                                `${discountType === "percentage"
                                                                    ? `${discountValue || 0}%`
                                                                    : `${discountValue || 0} EGP`
                                                                } Discount on ${value || 0} EGP Bill`
                                                            );
                                                        }}
                                                    />
                                                </Field>
                                            </Section>

                                            {/* Bill Discount */}
                                            <Section title={t("Bill discount")}>
                                                <div className="grid grid-cols-2 gap-3">
                                                    <Field label={t("Discount type")}>
                                                        <Select
                                                            className="w-full"
                                                            size="large"
                                                            value={discountType}
                                                            onChange={(value) => setDiscountType(value)}
                                                            options={[
                                                                {
                                                                    value: "fixed",
                                                                    label: t("Fixed Amount (EGP)"),
                                                                },
                                                                {
                                                                    value: "percentage",
                                                                    label: t("Percentage (%)"),
                                                                },
                                                            ]}
                                                        />
                                                    </Field>

                                                    <Field label={discountType === "fixed" ? t("Discount Amount (EGP)") : t("Discount Percentage (%)")}>
                                                        <input
                                                            type="number"
                                                            min="0"
                                                            className={inputClass}
                                                            value={discountValue}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setDiscountValue(value);
                                                                setPromotionNameAmountOff(
                                                                    `${discountType === "percentage" ? `${value || 0}%` : `${value || 0} EGP`} Discount on ${totalBillAmountOff || 0} EGP Bill`
                                                                );
                                                            }}
                                                        />
                                                    </Field>
                                                </div>
                                            </Section>

                                            {/* Validity */}
                                            <Section title={t("Validity")}>
                                                <div className="grid grid-cols-2 gap-3">
                                                    <Field label={t("Start date")}>
                                                        <DatePicker
                                                            className="w-full h-[40px]"
                                                            showTime={{ format: "HH:mm" }}
                                                            format="YYYY-MM-DD HH:mm"
                                                            value={startDate ? dayjs(startDate) : null}
                                                            onChange={(date) =>
                                                                setStartDate(
                                                                    date ? date.format("YYYY-MM-DD HH:mm:[00]") : ""
                                                                )
                                                            }
                                                            disabledDate={(current) =>
                                                                current && current < dayjs().startOf("day")
                                                            }
                                                        />
                                                    </Field>

                                                    <Field label={t("End date")}>
                                                        <DatePicker
                                                            className="w-full h-[40px]"
                                                            showTime={{ format: "HH:mm" }}
                                                            format="YYYY-MM-DD HH:mm"
                                                            value={endDate ? dayjs(endDate) : null}
                                                            onChange={(date) =>
                                                                setEndDate(
                                                                    date ? date.format("YYYY-MM-DD HH:mm:[00]") : ""
                                                                )
                                                            }
                                                            disabledDate={(current) =>
                                                                current &&
                                                                current <
                                                                (startDate
                                                                    ? dayjs(startDate).startOf("day")
                                                                    : dayjs().startOf("day"))
                                                            }
                                                        />
                                                    </Field>
                                                </div>
                                            </Section>

                                            {/* Summary */}
                                            <Section title={t("Summary")}>
                                                <div className="grid grid-cols-2 gap-3">
                                                    <div>
                                                        <p className="text-xs text-[#5B75A1]">
                                                            {t("Discount Type")}
                                                        </p>
                                                        <p className="text-sm font-bold text-[#343C6A]">
                                                            {discountType === "fixed"
                                                                ? t("Fixed Amount")
                                                                : t("Percentage")}
                                                        </p>
                                                    </div>

                                                    <div>
                                                        <p className="text-xs text-[#5B75A1]">
                                                            {t("Discount Value")}
                                                        </p>
                                                        <p className="text-sm font-bold text-[#343C6A]">
                                                            {discountType === "fixed"
                                                                ? `EGP ${discountValue || 0}`
                                                                : `${discountValue || 0}%`}
                                                        </p>
                                                    </div>
                                                </div>
                                            </Section>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CashierOffers;